import {
  CreateIsoCodeMappingCommand,
  IsoCodeMappingResponseDto,
  UpdateIsoCodeMappingCommand,
} from '@admin/app/api'
import { IsoCodeMappingStore } from '@admin/stores/IsoCodeMapping.store'
import { action, computed, makeObservable, observable } from 'mobx'
import { IsoCodeMapping, IsoCodeMappingFormData } from '../models/IsoCodeMapping.model'

export class IsoCodeMappingUIStore {
  filter = ''
  isFormDialogOpen = false
  isDeleteDialogOpen = false

  dataToBeEdited?: IsoCodeMappingFormData

  filteredStandardIsoCode?: IsoCodeMappingResponseDto

  constructor(public isoCodeMappingStore: IsoCodeMappingStore) {
    makeObservable(this, {
      filter: observable,
      dataToBeEdited: observable,
      isFormDialogOpen: observable,
      isDeleteDialogOpen: observable,
      filteredStandardIsoCode: observable,

      isoCodeMappings: computed,

      setFilter: action,
      toggleFormDialog: action,
      toggleDeleteDialog: action,
      setFilteredStandardIsoCode: action,
      setDataToBeEdited: action,
    })
  }

  get isoCodeMappings() {
    const filteredItems = this.isoCodeMappingStore.items.filter(item =>
      item.isoCode?.toLocaleUpperCase().includes(this.filter?.toLocaleUpperCase()),
    )

    if (this.filteredStandardIsoCode) {
      filteredItems.unshift(this.filteredStandardIsoCode)
    }
    const isoCodeMappings: IsoCodeMapping[] = filteredItems.map(item => {
      return {
        ...item,
        isoCodeMappingType: item.id === 0 ? 'Standard' : 'Custom',
      }
    })

    return isoCodeMappings
  }

  setDataToBeEdited = (data?: IsoCodeMappingFormData) => (this.dataToBeEdited = data)

  setFilter = (filter: string) => (this.filter = filter)

  setFilteredStandardIsoCode = (standardIsoCode?: IsoCodeMappingResponseDto) =>
    (this.filteredStandardIsoCode = standardIsoCode)

  toggleFormDialog = (shouldOpen: boolean, data?: IsoCodeMappingFormData) => {
    this.isFormDialogOpen = shouldOpen
    this.dataToBeEdited = data
  }

  toggleDeleteDialog = (shouldOpen: boolean) => (this.isDeleteDialogOpen = shouldOpen)

  resetFilteredStandardIsoCode = (isoCode: string) => {
    if (isoCode === this.filteredStandardIsoCode?.isoCode) {
      this.setFilteredStandardIsoCode()
    }
  }

  onDelete = async (id: number, isoCode: string) => {
    await this.isoCodeMappingStore.delete(id)
    this.resetFilteredStandardIsoCode(isoCode)
  }

  onSubmit = async (data: IsoCodeMappingFormData) => {
    const isEditMode = !!data.id
    let id

    if (isEditMode) {
      const cmd: UpdateIsoCodeMappingCommand = {
        ...data,
        id: data.id!,
      }
      id = await this.isoCodeMappingStore.update(cmd)
    } else {
      const cmd: CreateIsoCodeMappingCommand = {
        ...data,
        length: data.length ?? 0,
      }
      id = await this.isoCodeMappingStore.add(cmd)
    }
    this.resetFilteredStandardIsoCode(data.isoCode)
    return id
  }
}
